



























import Vue from 'vue';
import {
  ModalMixin,
  Modal,
  Message,
  notify,
  AsyncBtn,
} from 'mycorems-app-shared';
import { PaymentMethod, StripeForm as StripeFormElement, Modal as ModalElement } from '../types';
import { add } from './payment-method';
import StripeForm from './stripe/StripeForm.vue';

interface Data {
  task: Promise<PaymentMethod>|null
  error: string|null,
}

export default Vue.extend({
  mixins: [ModalMixin],
  components: {
    Modal,
    Message,
    StripeForm,
    AsyncBtn,
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      error: null,
    };
  },
  methods: {
    save() {
      this.task = (this.$refs.stripeForm as StripeFormElement)
        .createPaymentMethod()
        .then(this.add);
      this.task.then((paymentMethod: PaymentMethod) => {
        this.$emit('ok', paymentMethod);
        (this.$refs.modal as ModalElement).hide();
        notify.success('Payment method added.');
      });
    },
    add(paymentMethodId: string): Promise<PaymentMethod> {
      return add(this.customerId, paymentMethodId);
    },
  },
});
